import React, { useEffect, useRef, useState } from "react"
import { setSubmitFailed } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { Card, CardBody, Col, Row } from "reactstrap"
import { SaveButton } from "components/Buttons"
import { connect } from "react-redux"
import ReactDragListView from "react-drag-listview/lib/index.js"
import Table from "components/Table"
import ModalComponent from "components/Modals"
import TriviaChallenge from "./triviaChallenge"
import triviaChallengeListColumns from "./triviaChallengeListColumns"
import {
  addTriviaChallenge,
  deleteTriviaChallenge,
  getTriviaChallengeList,
  hideDeleteTriviaModal,
  openDeleteTriviaModal,
  resetTriviaList,
  updateTriviaChallenge,
  updateTriviaListItem,
  updateTriviaOrder,
} from "store/actions"
import { mapTriviaChallengeToAPi, mapUpdatedTriviaToApi } from "../utils"
import PropTypes from "prop-types"
import { LoadingIndicator } from "components/LoadingIndicator"

const TriviaChallengeList = props => {
  useEffect(() => {
    props.getTriviaChallengeList({
      ...(!!props?.selectedEvent ? { event_id: props.selectedEvent.id } : {}),
      menu_item_id: props.feature.id,
    })
    return () => {
      props?.resetTriviaList()
    }
  }, [])

  const [renderTriviaChallengeForm, setRenderTriviaChallengeForm] =
    useState(false)
  const [editableItem, setEditableItem] = useState(null)
  const [notificationModalIsOpen, setNotificationModalIsOpen] = useState(false)
  const [publishProps, setPublishProps] = useState(null)
  const selectedEventRef = useRef(props.selectedEvent)

  useEffect(() => {
    if (props.selectedEvent) {
      selectedEventRef.current = props.selectedEvent
    }
  }, [props.selectedEvent])

  const editActionHandler = item => {
    setEditableItem(item)
    setRenderTriviaChallengeForm(true)
  }

  const [selectedListItem, setSelectedListItem] = useState()
  const deleteActionHandler = item => {
    setSelectedListItem(item)
    props.openDeleteTriviaModal()
  }

  const actions = [
    {
      name: "Edit",
      onClick: editActionHandler,
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Delete",
      onClick: deleteActionHandler,
      icon: "bx bx-trash",
      isAvailable: true,
    },
  ]

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      const sortedList = [...props.triviaChallengeList].sort(
        (a, b) => a.order - b.order
      )
      const modifiedList = [...sortedList]

      const item = modifiedList.splice(fromIndex, 1)[0]
      modifiedList.splice(toIndex, 0, item)

      const modifiedItems = modifiedList.map((item, index) => {
        if (item.id !== sortedList[index].id) {
          return { ...item, order: index + 1 }
        } else {
          return null
        }
      })

      modifiedItems.forEach(item => {
        if (item) {
          props.updateTriviaOrder({
            ...item,
            questions: item.questions.map(x => x.id),
          })
        }
      })
    },
    nodeSelector: "tr",
    handleSelector: "tr",
    lineClassName: "dragDropLine",
  }

  const statusChangeHandler = (item, status) => {
    const selectedEvent = selectedEventRef?.current
    const data = {
      ...item,
      questions: item.questions.map(x => x.id),
      status: status,
    }
    if (status) {
      if (props.isEventFeature) {
        if (selectedEvent?.published) {
          setPublishProps(data)
          setNotificationModalIsOpen(true)
        } else {
          props.updateTriviaListItem(data)
        }
      } else {
        setPublishProps(data)
        setNotificationModalIsOpen(true)
      }
    } else {
      props.updateTriviaListItem(data)
    }
  }

  const handleAddItem = data => {
    if (!editableItem) {
      const [questions, trivia] = mapTriviaChallengeToAPi({
        ...data.trivia_challenge_form,
        eventId: !!props?.selectedEvent ? props.selectedEvent.id : null,
        menu_feature: false,
        menu_item_id: props.feature.id,
        name: data.trivia_challenge_form.name,
        order: 0,
        status: 0,
        userId: props.userId,
        vendorId: props.vendorId,
      })
      props.addTriviaChallenge({ questions, trivia })
      setRenderTriviaChallengeForm(false)
    } else {
      const [newQuestions, updatedQuestions, trivia] = mapUpdatedTriviaToApi(
        data.trivia_challenge_form,
        editableItem
      )
      props.updateTriviaChallenge({ newQuestions, updatedQuestions, trivia })
      setRenderTriviaChallengeForm(false)
      setEditableItem(null)
    }
  }

  return (
    <>
      {renderTriviaChallengeForm ? (
        <TriviaChallenge
          feature={
            editableItem
              ? { entity_id: editableItem?.id, label: "" }
              : { ...props.feature, label: "" }
          }
          handleAddListItem={handleAddItem}
          isListItem={true}
          backButtonHandler={() => {
            setRenderTriviaChallengeForm(false)
            setEditableItem(null)
          }}
          design={props.design}
        />
      ) : props?.listLoading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm">
            <Row>
              <Col>
                <h3>{props.feature.label}</h3>
              </Col>
            </Row>
            <Row className="mt-2">
              <ReactDragListView {...dragProps}>
                <Table
                  data={props.triviaChallengeList}
                  columns={triviaChallengeListColumns(statusChangeHandler)}
                  classes={"table align-middle"}
                  actions={actions}
                />
              </ReactDragListView>
            </Row>
            <Row>
              <Col xs="auto">
                <SaveButton
                  fullWidth={true}
                  type="button"
                  content="Add New Trivia"
                  onClick={() => setRenderTriviaChallengeForm(true)}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
      <ModalComponent
        title={`Delete Trivia Challenge - ${selectedListItem?.name}`}
        open={props.isDeleteTriviaModalOpen}
        onClose={props.hideDeleteTriviaModal}
      >
        <Row>
          <h5>
            If you delete this Trivia Challenge, all results and data associated
            with it will be deleted.
          </h5>
        </Row>
        <Row className="mt-3">
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              color="danger"
              content="Cancel"
              onClick={props.hideDeleteTriviaModal}
            />
          </Col>
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              content="Delete"
              onClick={() =>
                props.deleteTriviaChallenge({
                  id: selectedListItem.id,
                  menu_item_id: selectedListItem.menu_item_id,
                })
              }
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        open={notificationModalIsOpen}
        onClose={() => setNotificationModalIsOpen(false)}
      >
        <Row>
          <h5>
            Would you like to send a notification to your users that this trivia
            has been created?
          </h5>
        </Row>
        <Row className="mt-3 d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              content="No"
              onClick={() => {
                if (publishProps) {
                  props.updateTriviaListItem(publishProps)
                }
                setNotificationModalIsOpen(false)
              }}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Yes"
              onClick={() => {
                if (publishProps) {
                  props.updateTriviaListItem({
                    ...publishProps,
                    send_notification: 1,
                  })
                }
                setNotificationModalIsOpen(false)
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
    </>
  )
}

const mapStateToProps = state => ({
  selectedEvent: state.experiences.selectedEvent,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  triviaChallengeList: state.TriviaChallenge.triviaChallengeList,
  listLoading: state.TriviaChallenge.listLoading,
  isDeleteTriviaModalOpen: state.TriviaChallenge.isDeleteTriviaModalOpen,
})

const mapDispatchToProps = dispatch => ({
  setSubmitFailed: fields =>
    dispatch(setSubmitFailed(FORM_NAMES.TRIVIA_CHALLENGE, ...fields)),
  addTriviaChallenge: values => dispatch(addTriviaChallenge(values)),
  getTriviaChallengeList: values => dispatch(getTriviaChallengeList(values)),
  updateTriviaChallenge: values => dispatch(updateTriviaChallenge(values)),
  openDeleteTriviaModal: () => dispatch(openDeleteTriviaModal()),
  hideDeleteTriviaModal: () => dispatch(hideDeleteTriviaModal()),
  deleteTriviaChallenge: values => dispatch(deleteTriviaChallenge(values)),
  updateTriviaListItem: values => dispatch(updateTriviaListItem(values)),
  updateTriviaOrder: values => dispatch(updateTriviaOrder(values)),
  resetTriviaList: () => dispatch(resetTriviaList()),
})

TriviaChallengeList.propTypes = {
  feature: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(TriviaChallengeList)
